const PlusIcon = () => {
    return (
        <i className="fa-solid fa-plus"></i>
    );
}

export default PlusIcon;